import { gql } from 'graphql-request';

export const FETCH_EPISODES = gql`
  query ($filter: EpisodeFilter) {
    episodes(filter: $filter) {
      __typename
      id
      title
      originalTitle
      image {
        list
        cover
        listClean
        sticker
        svodCover
        appCover
        channelSquare
        channelList
        square
        portrait
        logo
        verticalBanner
        mobileBanner
        desktopBanner
        banner4k
      }
      genres {
        id
        value
      }
      tags
      slug
      position
      showViewCount
      contents {
        ... on Episode {
          id
          title
          originalTitle
          duration
          contentOwner
          businessType
          genres {
            id
            value
          }
          languages
          description
          assetType
          assetSubType
          releaseDate
          image {
            list
            cover
            listClean
            appCover
            square
            portrait
          }
          actors
          ageRating
          audioLanguages
          subtitleLanguages
          tags
          introStartTime
          introEndTime
          episodeNumber
          billingType
          tier
          seoTitle
          slug
          webUrl
          rating
          releaseDate
          video {
            url
            drmKey
            hlsUrl
            isDrm
          }
          tvShow {
            id
            title
            assetSubType
            originalTitle
          }
        }
      }
      nextUrl
      page
      size
      totalResults
    }
  }
`;
